import contentRequest from '~/src/services/api/api-content';
import { captureQueryError, TResponse } from '~/src/services/api/helper';

export interface ICitiesAliasTariffs {
    bundles: string[];
    mono: string[];
}

export type TDataResponse = TResponse<ICitiesAliasTariffs, any>;

export const getTariffsAliases = async (): Promise<TDataResponse> => {
    const url = '/v1/city/tariff-aliases';

    try {
        const response = await contentRequest().get<ICitiesAliasTariffs>(url);

        return {
            isSuccess: true,
            payload: response.data,
        };
    } catch (error) {
        return captureQueryError(error);
    }
};
